import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import { SEEN_KEY } from '../components/MessageBell';

const CSS = `
  .ms { min-height: 100vh; min-height: 100dvh; background: #F6F2EC; font-family: 'Inter', system-ui, sans-serif; color: #222; display: flex; flex-direction: column; max-width: 640px; margin: 0 auto; }
  .ms-top { background: #fff; border-bottom: 1px solid #E3DCCF; display: flex; align-items: center; gap: 10px; padding: 10px 14px; position: sticky; top: 0; z-index: 5; }
  .ms-back { background: none; border: 0; font-size: 24px; color: #173B34; width: 44px; height: 44px; cursor: pointer; margin-left: -8px; }
  .ms-av { width: 40px; height: 40px; border-radius: 20px; background: #173B34; color: #F6F2EC; font-weight: 800; text-align: center; line-height: 40px; flex: none; }
  .ms-top b { display: block; font-size: 16px; color: #173B34; } .ms-top span { font-size: 12.5px; color: #777; }
  .ms-body { flex: 1; padding: 16px 14px 12px; display: flex; flex-direction: column; gap: 9px; }
  .ms-day { align-self: center; font-size: 11.5px; color: #888; background: #fff; border: 1px solid #E3DCCF; border-radius: 99px; padding: 3px 10px; margin: 6px 0; }
  .ms-m { max-width: 82%; padding: 10px 13px; border-radius: 16px; font-size: 15px; line-height: 1.45; white-space: pre-wrap; word-break: break-word; }
  .ms-m small { display: block; font-size: 11px; opacity: .65; margin-top: 4px; }
  .ms-in { align-self: flex-start; background: #fff; border: 1px solid #E3DCCF; border-bottom-left-radius: 4px; }
  .ms-out { align-self: flex-end; background: #173B34; color: #fff; border-bottom-right-radius: 4px; }
  .ms-empty { text-align: center; color: #777; font-size: 14.5px; line-height: 1.5; padding: 40px 20px; }
  .ms-comp { position: sticky; bottom: 0; background: #fff; border-top: 1px solid #E3DCCF; padding: 10px 12px calc(10px + env(safe-area-inset-bottom)); }
  .ms-chips { display: flex; gap: 6px; flex-wrap: wrap; margin-bottom: 8px; }
  .ms-chips button { border: 1px solid #E3DCCF; background: #F6F2EC; border-radius: 99px; padding: 6px 11px; font-size: 12.5px; font-weight: 700; color: #173B34; cursor: pointer; font-family: inherit; }
  .ms-row { display: flex; gap: 8px; align-items: flex-end; }
  .ms-row textarea { flex: 1; border: 1.5px solid #E3DCCF; border-radius: 14px; padding: 11px 13px; font-size: 16px; font-family: inherit; resize: none; min-height: 48px; max-height: 140px; background: #F6F2EC; outline: none; }
  .ms-row textarea:focus { border-color: #173B34; }
  .ms-send { background: #E4572E; color: #fff; border: 0; border-radius: 14px; padding: 0 18px; min-height: 48px; font-weight: 700; font-size: 15px; font-family: inherit; cursor: pointer; }
  .ms-send:disabled { opacity: .55; }
  .ms-note { font-size: 11.5px; color: #888; margin-top: 7px; } .ms-err { color: #9b2c1f; font-size: 13px; margin-bottom: 6px; }
`;

const jour = (d) => new Date(d).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
const heure = (d) => new Date(d).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

export function MessagesPage() {
  const navigate = useNavigate();
  const [msgs, setMsgs] = useState(null);
  const [text, setText] = useState('');
  const [err, setErr] = useState('');
  const [sending, setSending] = useState(false);
  const end = useRef(null);

  const charger = async () => {
    try {
      const r = await api.messages();
      setMsgs(r.messages || []);
      try { localStorage.setItem(SEEN_KEY, new Date().toISOString()); } catch (e) {}
    } catch (e) { setMsgs(m => m || []); }
  };
  useEffect(() => { charger(); const t = setInterval(charger, 30000); return () => clearInterval(t); }, []);
  useEffect(() => { end.current && end.current.scrollIntoView({ block: 'end' }); }, [msgs]);

  const envoyer = async () => {
    setErr('');
    if (!text.trim()) return;
    setSending(true);
    try { await api.sendMessage(text.trim()); setText(''); await charger(); }
    catch (e) { setErr(e.message); }
    finally { setSending(false); }
  };

  let lastDay = '';
  return (
    <>
      <style>{CSS}</style>
      <div className="ms">
        <div className="ms-top">
          <button className="ms-back" onClick={() => navigate('/parcours')} aria-label="Retour">←</button>
          <div className="ms-av">D</div>
          <div><b>Dany, Stratvente</b><span>Je réponds en général sous 48 h</span></div>
        </div>
        <div className="ms-body">
          {msgs === null ? <div className="ms-empty">Chargement...</div> : msgs.length === 0 ? (
            <div className="ms-empty">Aucun message pour le moment.<br />Une question, un bug, une idée ? Écris-moi ci-dessous, je lis tout.</div>
          ) : msgs.map(m => {
            const j = jour(m.date); const show = j !== lastDay; lastDay = j;
            return (
              <div key={m.id} style={{ display: 'contents' }}>
                {show && <div className="ms-day">{j}</div>}
                <div className={`ms-m ${m.from === 'admin' ? 'ms-in' : 'ms-out'}`}>{m.text}<small>{heure(m.date)}</small></div>
              </div>
            );
          })}
          <div ref={end} />
        </div>
        <div className="ms-comp">
          <div className="ms-chips">
            {["J'ai une question sur un module", 'Un bug', 'Une idée'].map(c => <button key={c} onClick={() => setText(t => t || c + ' : ')}>{c}</button>)}
          </div>
          {err && <div className="ms-err">{err}</div>}
          <div className="ms-row">
            <textarea rows={1} maxLength={1000} value={text} onChange={e => setText(e.target.value)} placeholder="Écris ton message..." />
            <button className="ms-send" onClick={envoyer} disabled={sending || !text.trim()}>{sending ? '...' : 'Envoyer'}</button>
          </div>
          <div className="ms-note">Ton message est lu par Dany, pas par l'IA. 1000 caractères maximum.</div>
        </div>
      </div>
    </>
  );
}
